/* eslint-disable prettier/prettier */
/** DO NOT EDIT - This file is auto-generated by running `yarn workspace lib-shared-feature-flags update` */
const defaultFeatureFlags = {
    "a-c-forward": false,
    "activity-log-filters": true,
    "ada-chat-channel": false,
    "agent-activity-log": false,
    "agent-copilot": false,
    "agent-copilot-auto-translate": false,
    "agent-copilot-trial-eligibility": false,
    "allow-integration-api-token-usage": false,
    "allow-same-origin-in-sandboxed-custom-card-iframe": false,
    "analytics-custom-dashboards": false,
    "authorization-custom-role": false,
    "automation-ai-agent-single-interaction-action": false,
    "automation-automation-ai-agent": false,
    "automation-cel-expression": false,
    "automation-intent-detection-action": false,
    "automation-transcription-completed-trigger": false,
    "automations": false,
    "chatbot-quota-page": false,
    "chatbots-integration-settings": false,
    "contact-activity-log": false,
    "contact-memories-conversation-view": false,
    "conversation-assistant-for-dixa-messenger": false,
    "conversation-right-sidebar-visibility": false,
    "csat-for-dixa-messenger": false,
    "csat-for-email": false,
    "csat-for-widget-chat": false,
    "custom-analytics": true,
    "custom-attributes-suggestions": false,
    "custom-away-status": false,
    "desktop-app-notice-modal": true,
    "dev-api-authorization-scopes": false,
    "digitalgenius-chat-channel": false,
    "dixa-rewind": false,
    "elevio-suggestions": false,
    "email-channel": true,
    "email-templates-customization": false,
    "enable-call-recordings": true,
    "enable-restricted-queues": false,
    "export-conversations": false,
    "facebook-messenger-channel": true,
    "generic-api-messaging-channel": true,
    "has-bulk-operations": false,
    "has-chat-with-dixa-support": true,
    "has-custom-form-tel-email-fields": false,
    "has-messenger": true,
    "instagram-management": true,
    "integrations-for-dixa-messenger": false,
    "integrations-for-email": true,
    "integrations-for-phone": true,
    "intent-detection": false,
    "intent-detection-character-limit": 300,
    "kindly-chat-channel": false,
    "knowledge-access": true,
    "knowledge-articles-ai-auto-translations": false,
    "knowledge-management-nav": false,
    "knowledge-suggestions": true,
    "legacy-presence-sidebar": true,
    "message-auto-redaction": false,
    "mim-automation-variant": false,
    "mim-chatbot": false,
    "mim-conversation-data-source": false,
    "mim-drafts": false,
    "mim-integration-tools-shopify": true,
    "mim-markdown": true,
    "mim-one-settings-page": false,
    "mim-sidekick": false,
    "mim-versioning": false,
    "mim-web-kb-max-links-access": false,
    "new-search-conversations-view": false,
    "new-topbar": false,
    "organizations-sidebar": false,
    "partner-integrations-sidebar-conditions": false,
    "phone-channel": true,
    "redact-messages": false,
    "scheduled-conversations": false,
    "settings-add-ons-page": false,
    "shopify-marketplace-app": false,
    "show-tracking-card": true,
    "sidebar-cards-admin-management": false,
    "smart-article-create": false,
    "smart-article-create-multi-conversation": false,
    "sms-channel": false,
    "sms-compose": false,
    "survey-advanced-customization": false,
    "tag-suggestions-enabled": false,
    "telephony-numbers-data-residency-regions": false,
    "templates-language-translation-control": false,
    "trustpilot-channel": true,
    "use-birdeatsbug": false,
    "use-cleaned-up-telephony-middleware": false,
    "voice-ai-agent-action": false,
    "warm-transfer-to-queue": true,
    "website-data-source": false,
    "whatsapp-channel": true,
    "widget-chat-channel": false,
    "yotpo-channel": true
};

export { defaultFeatureFlags as default, defaultFeatureFlags };
//# sourceMappingURL=featureFlags.es.js.map
